import { gql } from 'urql';

export const LIST_ASIENTOS = gql`
  query ListAsientos($limit: Int, $offset: Int, $fechaDesde: String, $fechaHasta: String, $periodo: String, $estado: AsientoEstado, $origen: AsientoOrigen, $search: String) {
    listAsientos(
      pagination: { limit: $limit, offset: $offset }
      filter: { fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, periodo: $periodo, estado: $estado, origen: $origen, search: $search }
    ) {
      pageInfo {
        limit
        offset
        total
      }
      items {
        id
        empresaId
        fecha
        numero
        periodo
        origen
        glosa
        estado
        totales {
          debe
          haber
          diferencia
        }
      }
    }
  }
`;

export const GET_ASIENTO = gql`
  query GetAsiento($id: ID!) {
    getAsiento(id: $id) {
      id
      empresaId
      fecha
      numero
      periodo
      origen
      referenciaTipo
      referenciaId
      glosa
      estado
      detalle {
        id
        cuentaId
        cuentaCodigo
        cuentaNombre
        centroId
        centroNombre
        descripcion
        debe
        haber
        moneda
        tc
      }
      totales {
        debe
        haber
        diferencia
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREAR_ASIENTO = gql`
  mutation CrearAsiento($input: AsientoInput!) {
    crearAsiento(input: $input) {
      id
      fecha
      numero
      estado
    }
  }
`;

export const ACTUALIZAR_ASIENTO = gql`
  mutation ActualizarAsiento($id: ID!, $input: AsientoUpdateInput!) {
    actualizarAsiento(id: $id, input: $input) {
      id
      fecha
      numero
      estado
    }
  }
`;

export const CONFIRMAR_ASIENTO = gql`
  mutation ConfirmarAsiento($id: ID!) {
    confirmarAsiento(id: $id) {
      id
      estado
    }
  }
`;

export const ANULAR_ASIENTO = gql`
  mutation AnularAsiento($id: ID!, $motivo: String) {
    anularAsiento(id: $id, motivo: $motivo) {
      id
      numero
      estado
    }
  }
`;

